import { Handle, Position } from 'react-flow-renderer';
import PropTypes from 'prop-types';

const CustomNodeComponent = ({ data }) => {
    return (
        <div>
            <Handle type="target" position={Position.Left} className="handler" />
            <i className={data.icon}></i>
            <div className="data">{data.text}</div>
            <div className="label">{data.label}</div>

            <Handle
                type="source"
                position={Position.Right}
                id={data.pid}
                className="handler"
            />

            <div className="fileName">{data.filename}
                <p> {data.pid} </p>
            </div>
        </div>
    );
};

CustomNodeComponent.propTypes = {
    data: PropTypes.object.isRequired
};

export default CustomNodeComponent;
